import { useField } from 'formik';
import { useEffect, useState } from 'react';
import { useIsMounted } from 'usehooks-ts';
import { FIELD_NAMES } from '../constants';
import type { Values } from '../context';
import { useGetApiClient } from '../../../context/apiContext';
import type { VacationOptionsPresets } from '../components/DatePicker/types';
import { DEFAULT_NIGHTS_PRESET } from '../components/DatePicker/components/VacationOptionsPicker/components/DurationPicker/constants';

export const useFetchVacationOptionsPresets = (
  isVacationOptionsEnabled: boolean
): { vacationOptionsPresets: VacationOptionsPresets } => {
  const [{ value: destinationValue }] = useField<Values['destination']>(FIELD_NAMES.destination);
  const isMounted = useIsMounted();
  const api = useGetApiClient();

  const [vacationOptionsPresets, setVacationOptionsPresets] = useState<VacationOptionsPresets>({
    startDatePresets: [],
    nightsPresets: [],
    recommendedNightsPreset: DEFAULT_NIGHTS_PRESET,
  });

  useEffect(() => {
    if (isVacationOptionsEnabled) {
      api
        ?.getReferencesVacationOptions({
          destination_id: destinationValue?.value,
        })
        .then(({ startDatePresets, nightsPresets }) => {
          const recommendedNightsPreset =
            nightsPresets.find((preset) => preset.recommended) || DEFAULT_NIGHTS_PRESET;

          setVacationOptionsPresets({
            startDatePresets,
            nightsPresets,
            recommendedNightsPreset,
          });
        })
        .catch(console.error);
    }
  }, [destinationValue, isMounted]);

  return {
    vacationOptionsPresets,
  };
};
